var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtQuestionMatrix = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M230.717 42.192c11.561 0 20.934 9.373 20.934 20.934v153.52c0 11.563-9.373 20.935-20.934 20.935H49.283c-11.561 0-20.934-9.372-20.934-20.934V63.127c0-11.562 9.373-20.935 20.934-20.935zM126.044 167.799H56.262v41.87h69.782zm97.694 0h-69.782v41.87h69.782zm-97.694-69.782H56.262v41.87h69.782zm97.694 0h-69.782v41.87h69.782z"
})));
export default SvgQtQuestionMatrix;